interface UrlReadyData {
  data: {
    slot: {
      id: string;
    };
  };
}

/**
 * Ad Sticky Top for mew pages an newstab
 *
 * Always sticky on top of page
 */
export function AdStickyTopMew() {
  const namespace = window.AdService.getConfig('data-attribute-namespace') as string;
  const adSlotTopContainerElement = 'div[data-' + namespace + '-param-tagid="top"][data-' + namespace + '-slot="top"]';
  const adSlotTopContainer = document.querySelector(adSlotTopContainerElement);
  const adSlotTopContainerParent = adSlotTopContainer?.parentElement;
  const adSlotTopContainerParentParent = adSlotTopContainerParent?.parentElement?.parentElement; // CADNPCA-8670 one more wrapper
  let adSlotContentadContainerElementName: string;

  let contentadStarted = false;
  let isLeaving = false;

  const topMargin = (window.AdService.getParam('deviceclient') !== 'app') ? '34px' : 0;

  const css = {
    sticky: {
      position: 'sticky',
      top: topMargin,
      opacity: 1,
      zIndex: 1500,
      transition: 'opacity 0.25s ease-in-out'
    }
  };

  if (adSlotTopContainerParentParent) {
    Object.assign(adSlotTopContainerParentParent.style, css.sticky);
  }

  const fadeIn = () => {
    const keyframes = [
      {
        opacity: 0
      },
      {
        opacity: 1,
        position: 'sticky'
      }
    ];
    const options: KeyframeAnimationOptions = {
      duration: 250,
      iterations: 1,
      easing: 'ease-in-out',
      fill: 'forwards'
    };

    if (adSlotTopContainerParentParent) {
      adSlotTopContainerParentParent.animate(keyframes, options);
    }
  };

  const fadeOut = () => {
    const keyframes = [
      {
        opacity: 1,
        position: 'sticky'
      },
      {
        opacity: 0,
        position: 'static'
      }
    ];
    const options: KeyframeAnimationOptions = {
      duration: 250,
      iterations: 1,
      easing: 'ease-in-out',
      fill: 'forwards'
    };

    if (adSlotTopContainerParentParent) {
      adSlotTopContainerParentParent.animate(keyframes, options);
    }
  };

  window.AdService.on('ad.urlReady', (e: UrlReadyData) => {
    const s = window.AdService.getParam('layoutclass') === 's';
    if (s === true && contentadStarted !== true && ((e.data.slot.id === 'contentad') || (e.data.slot.id === 'relatedbox'))) {
      adSlotContentadContainerElementName = e.data.slot.id as string;
      observe();
      contentadStarted = true;
    }
  });

  const observe = () => {
    const adSlotContentadContainerElement = 'div[data-' + namespace + '-param-tagid="' + adSlotContentadContainerElementName + '"][data-' + namespace + '-slot="' + adSlotContentadContainerElementName + '"]';
    const adSlotContentadContainer = document.querySelector(adSlotContentadContainerElement);

    if (!adSlotContentadContainer) return;

    // Define observer
    const callback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if ((entry.isIntersecting) && (contentadStarted)) {
          fadeOut();
          isLeaving = true;
        } else if (isLeaving) {
          fadeIn();
          isLeaving = false;
        }
      });
    };

    const options = {
      rootMargin: document.body.offsetHeight + 'px 0px 0px 0px'
    };
    const observer = new IntersectionObserver(callback, options);
    // End Define Observer

    // Start Observer
    observer.observe(adSlotContentadContainer);
  };
}
